// extracted by mini-css-extract-plugin
export var topEllipsis = "ellipsis-module--topEllipsis--3V4iN";
export var bottomEllipsis = "ellipsis-module--bottomEllipsis--3q1S4";